import { AUTH_BASE_URL } from "../../props";
import { useGet, usePost, usePut } from "../../common/fetchServices";

const getSftpAccountUrl = ({ sftpAccountId }) =>
  `${AUTH_BASE_URL}/sftp/accounts/${sftpAccountId}`;

export const useSftpAccounts = () => {
  const url = `${AUTH_BASE_URL}/sftp/accounts`;
  return useGet(["sftp_accounts"], url);
};

export const useSftpAccountCreate = () => {
  const url = `${AUTH_BASE_URL}/sftp/accounts`;
  return usePost(() => url, {
    queriesToInvalidate: [["sftp_accounts"]],
  });
};

export const useSftpAccountUpdate = () => {
  return usePut(getSftpAccountUrl, {
    queriesToInvalidate: [["sftp_accounts"]],
  });
};
